import httpService from "./httpService";

export default {
  findAllChiefsParticipate(id) {
    let params = {
      hcCaseMasterId: id,
    }
    return httpService.get("hcCaseCalendarParticipantView/findAll", {
      params: params
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/hcCaseCalendarParticipantViewService.js